const state = {
    user: {
        name:'',
        id:''
    },
    baseUrl:'http://hkapi.topgene.cn'
	// baseUrl:'http://jxapi-test.cvddr.cn'
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js